import * as React from "react";
import { IDefaultViewProps } from "./IDefaultViewProps";
import { Caption } from "../../atoms/views/Caption";
import { ProblemenIcon } from "../../atoms/icons/ProblemenIcon";
import { useTranslation } from 'react-i18next';

// All the incoming values
interface IProps {
    value?: string[] | null;
}

// Outgoing functions
interface IDispatch {
}

// Actual Component
export type AllProps = IProps & IDispatch & Omit<IDefaultViewProps<string[] | null>, 'value'>;
export const Problemen = (props: AllProps) => {
    const { t: tDatatypes } = useTranslation('datatypes');
    
    const formatProblems = () => {
        if (!props.value || props.value.length === 0) {
            return '-';
        }
        return props.value.join(', ');
    };
    
    const label = props.label || tDatatypes('problemenLabel') || "Bijkomende uitdagingen";
    return (<Caption loading={props.loading} caption={label} icon={<ProblemenIcon />}>
        {formatProblems()}
    </Caption>)
}

